import { useEffect, useState } from 'react';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import GridRoomDetail from './GridRoom/GridRoomDetail';

const responsive = {
  desktop: {
    breakpoint: {
      max: 3000,
      min: 1024,
    },
    items: 1,
    paritialVisibilityGutter: 40,
  },
  mobile: {
    breakpoint: {
      max: 464,
      min: 0,
    },
    items: 1,
    paritialVisibilityGutter: 30,
  },
  tablet: {
    breakpoint: {
      max: 1024,
      min: 464,
    },
    items: 1,
    paritialVisibilityGutter: 30,
  },
};

const RoomDescription = ({
    images, id, hotel, dayUseParams
}) => {
  
  const [chambreData, setChambreData] = useState({});

  useEffect (() =>{
    const fetchDataSource = () => {
      fetch(`${process.env.REACT_APP_API_URL}/chambre-type-hebergements/${id}`,{
        headers : {
          "Content-Type": "application/json",
        }
      }).then(
        (res) =>
          res.json().then((response => {
              setChambreData(response)
              //setLoading(false);
          }))
      );
    }

    fetchDataSource();
    
  },[id]);

  return (
    <GridRoomDetail
      isCarousel={true}
      chambreData={chambreData}
      hotel={hotel}
      dayUseParams={dayUseParams}

    >
      <Carousel
        additionalTransfrom={0}
        arrows
        autoPlaySpeed={3000}
        containerClass="container"
        dotListClass=""
        draggable
        focusOnSelect={false}
        infinite
        itemClass=""
        renderDotsOutside={false}
        responsive={responsive}
        showDots={true}
        sliderClass=""
        slidesToSlide={1}
      >
        {images.map(({ url, name }, index) => (
          <img
            src={`${process.env.REACT_APP_API_URL}/${url}`}
            alt={name}
            key={index}
            draggable={false}
            style={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              position: 'relative',
            }}
          />
        ))}
      </Carousel>
    </GridRoomDetail>
    
  );
};

export default RoomDescription;
